// @flow
import * as React from 'react';
import {ComponentProps} from 'react';
import { ApolloProvider } from '@apollo/client';
import { ZipSelectorCompact } from '@coverright/features';
import { mainBackendApolloClient } from '@coverright/data-access/apollo-clients';

export const ZipSelector = (props: ComponentProps<typeof ZipSelectorCompact>) => {
  return (
    <ApolloProvider client={mainBackendApolloClient}>
      <ZipSelectorCompact {...props} />
    </ApolloProvider>
  );
};
